import Dropdown from "components/components/Dropdown/Dropdown";
import React from "react";

export enum Region {
  AllRegions = "All regions",
  NorthScotland = "North Scotland",
  SouthScotland = "South Scotland",
  NorthWest = "North West",
  NorthEast = "North East",
  Midlands = "Midlands",
  SouthWest = "South West",
  SouthEast = "South East",
}

interface Props {
  regionFilter: Region;
  setRegionFilter: (regionFilter: Region) => void;
}

export const RegionFilter: React.FC<Props> = ({
  regionFilter,
  setRegionFilter,
}: Props) => (
  <div data-test-id="region-filter">
    <Dropdown
      values={Object.values(Region)}
      selectedValue={regionFilter}
      onChange={(newValue: string): void => setRegionFilter(newValue as Region)}
      ariaLabel="Region dropdown"
      label="Region"
    />
  </div>
);
